import React, { useEffect, useState } from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import LandingPage from './pages/LandingPage';
import Login from './pages/auth/Login';
import Signup from './pages/auth/Signup';
import ForgotPassword from './pages/auth/ForgotPassword';
import ResetPassword from './pages/auth/ResetPassword';
import Portal from './pages/Portal';
import { authFetch } from './api';

function App() {
  const [isAuthenticated, setIsAuthenticated] = useState(null);

  useEffect(() => {
    const checkSession = async () => {
      const res = await authFetch('get-session');
      if (res?.data?.user) {
        localStorage.setItem('user_id', res.data.user.id);
        setIsAuthenticated(true);
      } else {
        localStorage.removeItem('user_id');
        setIsAuthenticated(false);
      }
    };
    checkSession();
  }, []);

  if (isAuthenticated === null) {
    return <div className="min-h-screen flex items-center justify-center bg-[#FAFAFA]">Laddar...</div>;
  }

  return (
    <Router>
      <Routes>
        <Route path="/" element={<LandingPage />} />
        <Route path="/login" element={!isAuthenticated ? <Login /> : <Navigate to="/portal" />} />
        <Route path="/signup" element={!isAuthenticated ? <Signup /> : <Navigate to="/portal" />} />
        <Route path="/forgot-password" element={<ForgotPassword />} />
        <Route path="/reset-password" element={<ResetPassword />} />
        <Route path="/portal/*" element={isAuthenticated ? <Portal /> : <Navigate to="/login" />} />
      </Routes>
    </Router>
  );
}

export default App;